/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
};

/** Auth type */
export type AuthType =
  | 'SESSION'
  | 'TOKEN';

export type AuthorizationResult = {
  __typename?: 'AuthorizationResult';
  /** Human-readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Reasons of check failure */
  reasons?: Maybe<FailureReasons>;
  /** Result of applying a policy rule */
  value: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ContactMessageCreate */
export type ContactMessageCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactMessageInput: ContactMessageInput;
};

/** Autogenerated return type of ContactMessageCreate. */
export type ContactMessageCreatePayload = {
  __typename?: 'ContactMessageCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ContactMessageInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  wpId?: InputMaybe<Scalars['String']['input']>;
};

/** Direction of a contact message reply */
export type ContactMessageReplyDirection =
  | 'INBOUND'
  | 'OUTBOUND';

/** Triage status for a contact message */
export type ContactMessageStatus =
  | 'CLOSED'
  | 'NEW'
  | 'REPLIED';

/** Autogenerated input type of CredentialsUserAuth */
export type CredentialsUserAuthInput = {
  authType?: InputMaybe<AuthType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
};

/** Autogenerated return type of CredentialsUserAuth. */
export type CredentialsUserAuthPayload = {
  __typename?: 'CredentialsUserAuthPayload';
  authToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csrfToken: Scalars['String']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of EmailTokenUserAuth */
export type EmailTokenUserAuthInput = {
  authType?: InputMaybe<AuthType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Autogenerated return type of EmailTokenUserAuth. */
export type EmailTokenUserAuthPayload = {
  __typename?: 'EmailTokenUserAuthPayload';
  authToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csrfToken: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EmailUserAuthChallenge */
export type EmailUserAuthChallengeInput = {
  clientAuthCode: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EmailUserAuthChallenge. */
export type EmailUserAuthChallengePayload = {
  __typename?: 'EmailUserAuthChallengePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  needsProfile: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type FailureReasons = {
  __typename?: 'FailureReasons';
  /** JSON-encoded map of reasons */
  details: Scalars['String']['output'];
  /** Human-readable errors */
  fullMessages: Array<Scalars['String']['output']>;
};

export type InternalAdminContactMessage = Node & {
  __typename?: 'InternalAdminContactMessage';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  puzzleWpId?: Maybe<Scalars['String']['output']>;
  replies: Array<InternalAdminContactMessageReply>;
  status: ContactMessageStatus;
  subject?: Maybe<Scalars['String']['output']>;
  submitterEmail?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for InternalAdminContactMessage. */
export type InternalAdminContactMessageConnection = {
  __typename?: 'InternalAdminContactMessageConnection';
  /** A list of edges. */
  edges: Array<InternalAdminContactMessageEdge>;
  /** A list of nodes. */
  nodes: Array<InternalAdminContactMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InternalAdminContactMessageEdge = {
  __typename?: 'InternalAdminContactMessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InternalAdminContactMessage>;
};

export type InternalAdminContactMessageReply = Node & {
  __typename?: 'InternalAdminContactMessageReply';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  direction: ContactMessageReplyDirection;
  fromEmail?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  senderEmail?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of InternalAdminContactMessageReplyCreate */
export type InternalAdminContactMessageReplyCreateInput = {
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminContactMessageReplyCreate. */
export type InternalAdminContactMessageReplyCreatePayload = {
  __typename?: 'InternalAdminContactMessageReplyCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactMessage: InternalAdminContactMessage;
};

/** Autogenerated input type of InternalAdminContactMessageUpdateStatus */
export type InternalAdminContactMessageUpdateStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status: ContactMessageStatus;
};

/** Autogenerated return type of InternalAdminContactMessageUpdateStatus. */
export type InternalAdminContactMessageUpdateStatusPayload = {
  __typename?: 'InternalAdminContactMessageUpdateStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactMessage: InternalAdminContactMessage;
};

/** Autogenerated input type of InternalAdminJourneyLogDelete */
export type InternalAdminJourneyLogDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminJourneyLogDelete. */
export type InternalAdminJourneyLogDeletePayload = {
  __typename?: 'InternalAdminJourneyLogDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedId: Scalars['ID']['output'];
};

/** Autogenerated input type of InternalAdminJourneyLogHide */
export type InternalAdminJourneyLogHideInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminJourneyLogHide. */
export type InternalAdminJourneyLogHidePayload = {
  __typename?: 'InternalAdminJourneyLogHidePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  journeyLog: JourneyLog;
};

/** Autogenerated input type of InternalAdminJourneyLogUnhide */
export type InternalAdminJourneyLogUnhideInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminJourneyLogUnhide. */
export type InternalAdminJourneyLogUnhidePayload = {
  __typename?: 'InternalAdminJourneyLogUnhidePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  journeyLog: JourneyLog;
};

export type InternalAdminPuzzleInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  pieceCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PuzzleStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of InternalAdminPuzzleRegenerateQrCode */
export type InternalAdminPuzzleRegenerateQrCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminPuzzleRegenerateQrCode. */
export type InternalAdminPuzzleRegenerateQrCodePayload = {
  __typename?: 'InternalAdminPuzzleRegenerateQrCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  puzzle: Puzzle;
};

/** Autogenerated input type of InternalAdminPuzzleUpdate */
export type InternalAdminPuzzleUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  puzzleInput: InternalAdminPuzzleInput;
};

/** Autogenerated return type of InternalAdminPuzzleUpdate. */
export type InternalAdminPuzzleUpdatePayload = {
  __typename?: 'InternalAdminPuzzleUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  puzzle: Puzzle;
};

export type InternalAdminUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userRole?: InputMaybe<UserRole>;
  userStatus?: InputMaybe<UserStatus>;
};

/** Autogenerated input type of InternalAdminUserSuspend */
export type InternalAdminUserSuspendInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminUserSuspend. */
export type InternalAdminUserSuspendPayload = {
  __typename?: 'InternalAdminUserSuspendPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of InternalAdminUserUnsuspend */
export type InternalAdminUserUnsuspendInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of InternalAdminUserUnsuspend. */
export type InternalAdminUserUnsuspendPayload = {
  __typename?: 'InternalAdminUserUnsuspendPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of InternalAdminUserUpdate */
export type InternalAdminUserUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  userInput: InternalAdminUserInput;
};

/** Autogenerated return type of InternalAdminUserUpdate. */
export type InternalAdminUserUpdatePayload = {
  __typename?: 'InternalAdminUserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type JourneyLog = Node & {
  __typename?: 'JourneyLog';
  /** The author of this log when they're publicly attributable. Nil for anonymous logs or soft-deleted users. */
  author?: Maybe<User>;
  authorDisplayName: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  completedOn: Scalars['ISO8601Date']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayAs: JourneyLogDisplay;
  displayOnMap: Scalars['Boolean']['output'];
  hiddenAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  nextLocation?: Maybe<Scalars['String']['output']>;
  passedOn: Scalars['Boolean']['output'];
  photoThumbUrl?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  puzzle: Puzzle;
  state?: Maybe<Scalars['String']['output']>;
  /** True only when the current viewer is the author of this log. */
  viewerIsAuthor: Scalars['Boolean']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** The connection type for JourneyLog. */
export type JourneyLogConnection = {
  __typename?: 'JourneyLogConnection';
  /** A list of edges. */
  edges: Array<JourneyLogEdge>;
  /** A list of nodes. */
  nodes: Array<JourneyLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Autogenerated input type of JourneyLogCreate */
export type JourneyLogCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  journeyLogInput: JourneyLogInput;
  photoSignedId?: InputMaybe<Scalars['ID']['input']>;
  wpId: Scalars['String']['input'];
};

/** Autogenerated return type of JourneyLogCreate. */
export type JourneyLogCreatePayload = {
  __typename?: 'JourneyLogCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  journeyLog: JourneyLog;
};

/** How a journey log's author should be displayed */
export type JourneyLogDisplay =
  | 'ANONYMOUS'
  | 'FIRST_NAME';

/** An edge in a connection. */
export type JourneyLogEdge = {
  __typename?: 'JourneyLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<JourneyLog>;
};

export type JourneyLogInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  completedOn: Scalars['ISO8601Date']['input'];
  displayAs?: InputMaybe<JourneyLogDisplay>;
  nextLocation?: InputMaybe<Scalars['String']['input']>;
  passedOn?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of JourneyLogUpdate */
export type JourneyLogUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  journeyLogInput: JourneyLogInput;
  photoSignedId?: InputMaybe<Scalars['ID']['input']>;
  removePhoto?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of JourneyLogUpdate. */
export type JourneyLogUpdatePayload = {
  __typename?: 'JourneyLogUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  journeyLog: JourneyLog;
};

/** Autogenerated input type of Logout */
export type LogoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of Logout. */
export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Submit a contact message. Sends an auto-reply to the submitter. */
  contactMessageCreate: ContactMessageCreatePayload;
  credentialsUserAuth: CredentialsUserAuthPayload;
  /** Authenticate a user with an email token */
  emailTokenUserAuth: EmailTokenUserAuthPayload;
  /** Send a magic-link email. If the email isn't registered yet and name fields are provided, create the account first. */
  emailUserAuthChallenge: EmailUserAuthChallengePayload;
  /** Send an email reply to a contact message and store it on the thread. */
  internalAdminContactMessageReplyCreate: InternalAdminContactMessageReplyCreatePayload;
  /** Update the triage status on a contact message. */
  internalAdminContactMessageUpdateStatus: InternalAdminContactMessageUpdateStatusPayload;
  /** Permanently deletes a journey log and its attached photo. */
  internalAdminJourneyLogDelete: InternalAdminJourneyLogDeletePayload;
  /** Hides a journey log from the public timeline. */
  internalAdminJourneyLogHide: InternalAdminJourneyLogHidePayload;
  /** Restores a hidden journey log to the public timeline. */
  internalAdminJourneyLogUnhide: InternalAdminJourneyLogUnhidePayload;
  /** Re-enqueues the QR-code generation job for a puzzle. */
  internalAdminPuzzleRegenerateQrCode: InternalAdminPuzzleRegenerateQrCodePayload;
  /** Updates a puzzle by id (admin moderation). */
  internalAdminPuzzleUpdate: InternalAdminPuzzleUpdatePayload;
  /** Marks a user as blocked, preventing all authenticated actions. */
  internalAdminUserSuspend: InternalAdminUserSuspendPayload;
  /** Restores a blocked user to active status. */
  internalAdminUserUnsuspend: InternalAdminUserUnsuspendPayload;
  /** Updates a user by id */
  internalAdminUserUpdate: InternalAdminUserUpdatePayload;
  /** Log your stop on a puzzle's journey. */
  journeyLogCreate: JourneyLogCreatePayload;
  /** Update one of your journey logs. */
  journeyLogUpdate: JourneyLogUpdatePayload;
  logout: LogoutPayload;
  /** Register a new puzzle and its first journey log. Returns the puzzle with its generated wp_id. */
  puzzleCreate: PuzzleCreatePayload;
  /** Soft-delete the current viewer. Marks the user deleted_at and ends the session. */
  viewerSoftDelete: ViewerSoftDeletePayload;
  /** Updates the current viewer */
  viewerUpdate: ViewerUpdatePayload;
};


export type MutationContactMessageCreateArgs = {
  input: ContactMessageCreateInput;
};


export type MutationCredentialsUserAuthArgs = {
  input: CredentialsUserAuthInput;
};


export type MutationEmailTokenUserAuthArgs = {
  input: EmailTokenUserAuthInput;
};


export type MutationEmailUserAuthChallengeArgs = {
  input: EmailUserAuthChallengeInput;
};


export type MutationInternalAdminContactMessageReplyCreateArgs = {
  input: InternalAdminContactMessageReplyCreateInput;
};


export type MutationInternalAdminContactMessageUpdateStatusArgs = {
  input: InternalAdminContactMessageUpdateStatusInput;
};


export type MutationInternalAdminJourneyLogDeleteArgs = {
  input: InternalAdminJourneyLogDeleteInput;
};


export type MutationInternalAdminJourneyLogHideArgs = {
  input: InternalAdminJourneyLogHideInput;
};


export type MutationInternalAdminJourneyLogUnhideArgs = {
  input: InternalAdminJourneyLogUnhideInput;
};


export type MutationInternalAdminPuzzleRegenerateQrCodeArgs = {
  input: InternalAdminPuzzleRegenerateQrCodeInput;
};


export type MutationInternalAdminPuzzleUpdateArgs = {
  input: InternalAdminPuzzleUpdateInput;
};


export type MutationInternalAdminUserSuspendArgs = {
  input: InternalAdminUserSuspendInput;
};


export type MutationInternalAdminUserUnsuspendArgs = {
  input: InternalAdminUserUnsuspendInput;
};


export type MutationInternalAdminUserUpdateArgs = {
  input: InternalAdminUserUpdateInput;
};


export type MutationJourneyLogCreateArgs = {
  input: JourneyLogCreateInput;
};


export type MutationJourneyLogUpdateArgs = {
  input: JourneyLogUpdateInput;
};


export type MutationLogoutArgs = {
  input: LogoutInput;
};


export type MutationPuzzleCreateArgs = {
  input: PuzzleCreateInput;
};


export type MutationViewerSoftDeleteArgs = {
  input: ViewerSoftDeleteInput;
};


export type MutationViewerUpdateArgs = {
  input: ViewerUpdateInput;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Puzzle = Node & {
  __typename?: 'Puzzle';
  brand: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  homeCity?: Maybe<Scalars['String']['output']>;
  homeState?: Maybe<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  journeyLogCount: Scalars['Int']['output'];
  journeyLogs: JourneyLogConnection;
  owner?: Maybe<User>;
  photoThumbUrl?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  pieceCount: Scalars['Int']['output'];
  qrCodeUrl?: Maybe<Scalars['String']['output']>;
  registeredOn: Scalars['ISO8601DateTime']['output'];
  status: PuzzleStatus;
  title: Scalars['String']['output'];
  viewerHasLogged: Scalars['Boolean']['output'];
  viewerIsOwner: Scalars['Boolean']['output'];
  wpId: Scalars['String']['output'];
};


export type PuzzleJourneyLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Puzzle. */
export type PuzzleConnection = {
  __typename?: 'PuzzleConnection';
  /** A list of edges. */
  edges: Array<PuzzleEdge>;
  /** A list of nodes. */
  nodes: Array<Puzzle>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Autogenerated input type of PuzzleCreate */
export type PuzzleCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  journeyLogInput: JourneyLogInput;
  /** Optional separate photo for the first journey log (e.g. you with the puzzle). Falls back to the puzzle photo when omitted. */
  journeyLogPhotoSignedId?: InputMaybe<Scalars['ID']['input']>;
  /** Photo of the puzzle itself, becomes the puzzle hero image. */
  photoSignedId: Scalars['ID']['input'];
  puzzleInput: PuzzleInput;
};

/** Autogenerated return type of PuzzleCreate. */
export type PuzzleCreatePayload = {
  __typename?: 'PuzzleCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  puzzle: Puzzle;
};

/** An edge in a connection. */
export type PuzzleEdge = {
  __typename?: 'PuzzleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Puzzle>;
};

export type PuzzleInput = {
  brand: Scalars['String']['input'];
  pieceCount: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

/** Puzzle status enum */
export type PuzzleStatus =
  | 'ACTIVE'
  | 'INACTIVE'
  | 'REMOVED';

export type Query = {
  __typename?: 'Query';
  /** Paginated contact-message queue. */
  internalAdminContactMessages: InternalAdminContactMessageConnection;
  /** Paginated journey logs for admin moderation. */
  internalAdminJourneyLogs: JourneyLogConnection;
  /** Paginated puzzles for admin moderation. */
  internalAdminPuzzles: PuzzleConnection;
  internalAdminUsers: UserConnection;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  /** Look up a puzzle by its public WP-ID. */
  puzzle?: Maybe<Puzzle>;
  /** Aggregate counts shown on the public landing page. */
  siteStats: SiteStats;
  uiAccess: UiAccess;
  /** Look up a user's public profile by their cool_id. */
  user?: Maybe<User>;
  viewer?: Maybe<User>;
  /** Returns a JSON-serialized dump of the current viewer's profile, registered puzzles, and journey logs. */
  viewerDataExport: Scalars['String']['output'];
};


export type QueryInternalAdminContactMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ContactMessageStatus>;
};


export type QueryInternalAdminJourneyLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  puzzleWpId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInternalAdminPuzzlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PuzzleStatus>;
};


export type QueryInternalAdminUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNodeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNodesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPuzzleArgs = {
  wpId: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};

/** Aggregate counts shown on the public landing page. */
export type SiteStats = {
  __typename?: 'SiteStats';
  /** Up to 6 active puzzles that have most recently logged a step on their journey. */
  featuredPuzzles: Array<Puzzle>;
  journeyLogsCount: Scalars['Int']['output'];
  puzzlesRegisteredCount: Scalars['Int']['output'];
  /** Newest visible journey logs that have coordinates and are opted in to the map. */
  recentMapStops: Array<JourneyLog>;
};


/** Aggregate counts shown on the public landing page. */
export type SiteStatsRecentMapStopsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** UI access permissions for the current user */
export type UiAccess = {
  __typename?: 'UiAccess';
  canInternalAdmin: AuthorizationResult;
};

export type User = Node & {
  __typename?: 'User';
  avatarThumbUrl?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  defaultDisplayAs: JourneyLogDisplay;
  distinctStatesVisited: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  journeyLogs: Array<JourneyLog>;
  lastName: Scalars['String']['output'];
  myPuzzles: Array<Puzzle>;
  publicDisplayName: Scalars['String']['output'];
  publicDistinctStatesVisited: Scalars['Int']['output'];
  publicJourneyLogs: Array<JourneyLog>;
  publicMemberSince: Scalars['ISO8601DateTime']['output'];
  publicPuzzlesLoggedCount: Scalars['Int']['output'];
  publicPuzzlesRegisteredCount: Scalars['Int']['output'];
  publicRegisteredPuzzles: Array<Puzzle>;
  puzzlesLoggedCount: Scalars['Int']['output'];
  puzzlesRegisteredCount: Scalars['Int']['output'];
  registeredPuzzles: Array<Puzzle>;
  totalPiecesLogged: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userRole: UserRole;
  userStatus: UserStatus;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** A list of nodes. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** User role enum */
export type UserRole =
  | 'DEFAULT'
  | 'SYSTEM_ADMIN';

/** User status enum */
export type UserStatus =
  | 'ACTIVE'
  | 'BLOCKED'
  | 'INVITED';

export type ViewerInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  defaultDisplayAs?: InputMaybe<JourneyLogDisplay>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ViewerSoftDelete */
export type ViewerSoftDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ViewerSoftDelete. */
export type ViewerSoftDeletePayload = {
  __typename?: 'ViewerSoftDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ViewerUpdate */
export type ViewerUpdateInput = {
  avatarSignedId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  removeAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  viewerInput: ViewerInput;
};

/** Autogenerated return type of ViewerUpdate. */
export type ViewerUpdatePayload = {
  __typename?: 'ViewerUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersQuery = { __typename?: 'Query', internalAdminUsers: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', id: string, fullName: string, email?: string | null, createdAt?: string | null, userStatus: UserStatus } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type InternalAdminUserSuspendMutationVariables = Exact<{
  input: InternalAdminUserSuspendInput;
}>;


export type InternalAdminUserSuspendMutation = { __typename?: 'Mutation', internalAdminUserSuspend: { __typename?: 'InternalAdminUserSuspendPayload', user: { __typename?: 'User', id: string, userStatus: UserStatus } } };

export type InternalAdminUserUnsuspendMutationVariables = Exact<{
  input: InternalAdminUserUnsuspendInput;
}>;


export type InternalAdminUserUnsuspendMutation = { __typename?: 'Mutation', internalAdminUserUnsuspend: { __typename?: 'InternalAdminUserUnsuspendPayload', user: { __typename?: 'User', id: string, userStatus: UserStatus } } };

export type InternalAdminContactMessagesQueryVariables = Exact<{
  status?: InputMaybe<ContactMessageStatus>;
}>;


export type InternalAdminContactMessagesQuery = { __typename?: 'Query', internalAdminContactMessages: { __typename?: 'InternalAdminContactMessageConnection', nodes: Array<{ __typename?: 'InternalAdminContactMessage', id: string, name: string, email: string, subject?: string | null, message: string, status: ContactMessageStatus, createdAt: string, puzzleWpId?: string | null, submitterEmail?: string | null, replies: Array<{ __typename?: 'InternalAdminContactMessageReply', id: string, body: string, direction: ContactMessageReplyDirection, createdAt: string, fromName?: string | null, fromEmail?: string | null, senderEmail?: string | null, senderName?: string | null }> }> } };

export type InternalAdminContactMessageUpdateStatusMutationVariables = Exact<{
  input: InternalAdminContactMessageUpdateStatusInput;
}>;


export type InternalAdminContactMessageUpdateStatusMutation = { __typename?: 'Mutation', internalAdminContactMessageUpdateStatus: { __typename?: 'InternalAdminContactMessageUpdateStatusPayload', contactMessage: { __typename?: 'InternalAdminContactMessage', id: string, status: ContactMessageStatus } } };

export type InternalAdminContactMessageReplyCreateMutationVariables = Exact<{
  input: InternalAdminContactMessageReplyCreateInput;
}>;


export type InternalAdminContactMessageReplyCreateMutation = { __typename?: 'Mutation', internalAdminContactMessageReplyCreate: { __typename?: 'InternalAdminContactMessageReplyCreatePayload', contactMessage: { __typename?: 'InternalAdminContactMessage', id: string, status: ContactMessageStatus, replies: Array<{ __typename?: 'InternalAdminContactMessageReply', id: string, body: string, direction: ContactMessageReplyDirection, createdAt: string, fromName?: string | null, fromEmail?: string | null, senderEmail?: string | null, senderName?: string | null }> } } };

export type InternalAdminJourneyLogsQueryVariables = Exact<{
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  puzzleWpId?: InputMaybe<Scalars['String']['input']>;
}>;


export type InternalAdminJourneyLogsQuery = { __typename?: 'Query', internalAdminJourneyLogs: { __typename?: 'JourneyLogConnection', nodes: Array<{ __typename?: 'JourneyLog', id: string, completedOn: string, comment?: string | null, city?: string | null, state?: string | null, latitude?: number | null, longitude?: number | null, hiddenAt?: string | null, authorDisplayName: string, photoThumbUrl?: string | null, puzzle: { __typename?: 'Puzzle', id: string, wpId: string, title: string } }> } };

export type InternalAdminJourneyLogHideMutationVariables = Exact<{
  input: InternalAdminJourneyLogHideInput;
}>;


export type InternalAdminJourneyLogHideMutation = { __typename?: 'Mutation', internalAdminJourneyLogHide: { __typename?: 'InternalAdminJourneyLogHidePayload', journeyLog: { __typename?: 'JourneyLog', id: string, hiddenAt?: string | null } } };

export type InternalAdminJourneyLogUnhideMutationVariables = Exact<{
  input: InternalAdminJourneyLogUnhideInput;
}>;


export type InternalAdminJourneyLogUnhideMutation = { __typename?: 'Mutation', internalAdminJourneyLogUnhide: { __typename?: 'InternalAdminJourneyLogUnhidePayload', journeyLog: { __typename?: 'JourneyLog', id: string, hiddenAt?: string | null } } };

export type InternalAdminJourneyLogDeleteMutationVariables = Exact<{
  input: InternalAdminJourneyLogDeleteInput;
}>;


export type InternalAdminJourneyLogDeleteMutation = { __typename?: 'Mutation', internalAdminJourneyLogDelete: { __typename?: 'InternalAdminJourneyLogDeletePayload', deletedId: string } };

export type InternalAdminPuzzlesQueryVariables = Exact<{
  status?: InputMaybe<PuzzleStatus>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type InternalAdminPuzzlesQuery = { __typename?: 'Query', internalAdminPuzzles: { __typename?: 'PuzzleConnection', nodes: Array<{ __typename?: 'Puzzle', id: string, wpId: string, title: string, brand: string, pieceCount: number, description?: string | null, status: PuzzleStatus, registeredOn: string }> } };

export type InternalAdminPuzzleUpdateMutationVariables = Exact<{
  input: InternalAdminPuzzleUpdateInput;
}>;


export type InternalAdminPuzzleUpdateMutation = { __typename?: 'Mutation', internalAdminPuzzleUpdate: { __typename?: 'InternalAdminPuzzleUpdatePayload', puzzle: { __typename?: 'Puzzle', id: string, title: string, brand: string, pieceCount: number, description?: string | null, status: PuzzleStatus } } };

export type InternalAdminPuzzleRegenerateQrCodeMutationVariables = Exact<{
  input: InternalAdminPuzzleRegenerateQrCodeInput;
}>;


export type InternalAdminPuzzleRegenerateQrCodeMutation = { __typename?: 'Mutation', internalAdminPuzzleRegenerateQrCode: { __typename?: 'InternalAdminPuzzleRegenerateQrCodePayload', puzzle: { __typename?: 'Puzzle', id: string } } };

export type CachedUiAccessContextFragment = { __typename?: 'UiAccess', canInternalAdmin: { __typename?: 'AuthorizationResult', value: boolean } };

export type CachedViewerContextFragment = { __typename?: 'User', id: string, fullName: string, firstName: string, lastName: string, email?: string | null, createdAt?: string | null, avatarThumbUrl?: string | null, defaultDisplayAs: JourneyLogDisplay };

export type LogoutMutationVariables = Exact<{
  input: LogoutInput;
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutPayload', success: boolean } };

export type UiAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type UiAccessQuery = { __typename?: 'Query', uiAccess: { __typename?: 'UiAccess', canInternalAdmin: { __typename?: 'AuthorizationResult', value: boolean } } };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, fullName: string, firstName: string, lastName: string, email?: string | null, createdAt?: string | null, avatarThumbUrl?: string | null, defaultDisplayAs: JourneyLogDisplay } | null };

export type DashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, firstName: string, puzzlesLoggedCount: number, puzzlesRegisteredCount: number, totalPiecesLogged: number, myPuzzles: Array<{ __typename?: 'Puzzle', id: string, wpId: string, title: string, brand: string, pieceCount: number, homeCity?: string | null, homeState?: string | null, photoThumbUrl?: string | null, journeyLogCount: number, viewerIsOwner: boolean, viewerHasLogged: boolean, journeyLogs: { __typename?: 'JourneyLogConnection', nodes: Array<{ __typename?: 'JourneyLog', id: string, completedOn: string, city?: string | null, state?: string | null }> } }> } | null };

export type LandingStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type LandingStatsQuery = { __typename?: 'Query', siteStats: { __typename?: 'SiteStats', puzzlesRegisteredCount: number, journeyLogsCount: number, featuredPuzzles: Array<{ __typename?: 'Puzzle', id: string, wpId: string, title: string, brand: string, pieceCount: number, photoThumbUrl?: string | null }>, recentMapStops: Array<{ __typename?: 'JourneyLog', id: string, city?: string | null, state?: string | null, completedOn: string, authorDisplayName: string, latitude?: number | null, longitude?: number | null, photoThumbUrl?: string | null, puzzle: { __typename?: 'Puzzle', wpId: string, title: string } }> } };

export type LoginMutationVariables = Exact<{
  input: CredentialsUserAuthInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'CredentialsUserAuthPayload', user?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } };

export type EmailTokenAuthMutationVariables = Exact<{
  input: EmailTokenUserAuthInput;
}>;


export type EmailTokenAuthMutation = { __typename?: 'Mutation', emailTokenUserAuth: { __typename?: 'EmailTokenUserAuthPayload', success: boolean, csrfToken: string } };

export type EmailAuthChallengeMutationVariables = Exact<{
  input: EmailUserAuthChallengeInput;
}>;


export type EmailAuthChallengeMutation = { __typename?: 'Mutation', emailUserAuthChallenge: { __typename?: 'EmailUserAuthChallengePayload', success: boolean, needsProfile: boolean } };

export type ViewerUpdateMutationVariables = Exact<{
  input: ViewerUpdateInput;
}>;


export type ViewerUpdateMutation = { __typename?: 'Mutation', viewerUpdate: { __typename?: 'ViewerUpdatePayload', user: { __typename?: 'User', id: string, avatarThumbUrl?: string | null } } };

export type UpdateProfileMutationVariables = Exact<{
  input: ViewerUpdateInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', viewerUpdate: { __typename?: 'ViewerUpdatePayload', user: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email?: string | null, createdAt?: string | null, avatarThumbUrl?: string | null, defaultDisplayAs: JourneyLogDisplay } } };

export type ViewerSoftDeleteMutationVariables = Exact<{
  input: ViewerSoftDeleteInput;
}>;


export type ViewerSoftDeleteMutation = { __typename?: 'Mutation', viewerSoftDelete: { __typename?: 'ViewerSoftDeletePayload', success: boolean } };

export type ViewerDataExportQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerDataExportQuery = { __typename?: 'Query', viewerDataExport: string };

export type PublicProfileQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PublicProfileQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, firstName: string, publicDisplayName: string, bio?: string | null, avatarThumbUrl?: string | null, publicMemberSince: string, publicPuzzlesLoggedCount: number, publicPuzzlesRegisteredCount: number, publicDistinctStatesVisited: number, publicJourneyLogs: Array<{ __typename?: 'JourneyLog', id: string, completedOn: string, city?: string | null, state?: string | null, comment?: string | null, photoThumbUrl?: string | null, authorDisplayName: string, viewerIsAuthor: boolean, puzzle: { __typename?: 'Puzzle', id: string, wpId: string, title: string, brand: string, pieceCount: number, photoThumbUrl?: string | null } }>, publicRegisteredPuzzles: Array<{ __typename?: 'Puzzle', id: string, wpId: string, title: string, brand: string, pieceCount: number, homeCity?: string | null, homeState?: string | null, photoThumbUrl?: string | null, journeyLogCount: number }> } | null };

export type JourneyLogForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JourneyLogForEditQuery = { __typename?: 'Query', node?:
    | { __typename?: 'InternalAdminContactMessage' }
    | { __typename?: 'InternalAdminContactMessageReply' }
    | { __typename?: 'JourneyLog', id: string, completedOn: string, city?: string | null, state?: string | null, zipCode?: string | null, comment?: string | null, passedOn: boolean, nextLocation?: string | null, displayAs: JourneyLogDisplay, photoUrl?: string | null, viewerIsAuthor: boolean, puzzle: { __typename?: 'Puzzle', id: string, wpId: string, title: string, brand: string, pieceCount: number, photoThumbUrl?: string | null } }
    | { __typename?: 'Puzzle' }
    | { __typename?: 'User' }
   | null };

export type JourneyLogUpdateMutationVariables = Exact<{
  input: JourneyLogUpdateInput;
}>;


export type JourneyLogUpdateMutation = { __typename?: 'Mutation', journeyLogUpdate: { __typename?: 'JourneyLogUpdatePayload', journeyLog: { __typename?: 'JourneyLog', id: string } } };

export type LogJourneyPuzzleQueryVariables = Exact<{
  wpId: Scalars['String']['input'];
}>;


export type LogJourneyPuzzleQuery = { __typename?: 'Query', puzzle?: { __typename?: 'Puzzle', id: string, wpId: string, title: string, brand: string, pieceCount: number, photoThumbUrl?: string | null } | null };

export type JourneyLogCreateMutationVariables = Exact<{
  input: JourneyLogCreateInput;
}>;


export type JourneyLogCreateMutation = { __typename?: 'Mutation', journeyLogCreate: { __typename?: 'JourneyLogCreatePayload', journeyLog: { __typename?: 'JourneyLog', id: string } } };

export type PuzzleLabelQueryVariables = Exact<{
  wpId: Scalars['String']['input'];
}>;


export type PuzzleLabelQuery = { __typename?: 'Query', puzzle?: { __typename?: 'Puzzle', id: string, wpId: string, title: string, qrCodeUrl?: string | null } | null };

export type PuzzleTrackingQueryVariables = Exact<{
  wpId: Scalars['String']['input'];
}>;


export type PuzzleTrackingQuery = { __typename?: 'Query', puzzle?: { __typename?: 'Puzzle', id: string, wpId: string, title: string, brand: string, pieceCount: number, homeCity?: string | null, homeState?: string | null, registeredOn: string, photoUrl?: string | null, photoThumbUrl?: string | null, journeyLogCount: number, viewerIsOwner: boolean, journeyLogs: { __typename?: 'JourneyLogConnection', nodes: Array<{ __typename?: 'JourneyLog', id: string, completedOn: string, city?: string | null, state?: string | null, comment?: string | null, authorDisplayName: string, passedOn: boolean, nextLocation?: string | null, latitude?: number | null, longitude?: number | null, displayOnMap: boolean, photoUrl?: string | null, photoThumbUrl?: string | null, author?: { __typename?: 'User', id: string, firstName: string } | null }> } } | null };

export type PuzzleCreateMutationVariables = Exact<{
  input: PuzzleCreateInput;
}>;


export type PuzzleCreateMutation = { __typename?: 'Mutation', puzzleCreate: { __typename?: 'PuzzleCreatePayload', puzzle: { __typename?: 'Puzzle', id: string, wpId: string } } };

export type ContactMessageCreateMutationVariables = Exact<{
  input: ContactMessageCreateInput;
}>;


export type ContactMessageCreateMutation = { __typename?: 'Mutation', contactMessageCreate: { __typename?: 'ContactMessageCreatePayload', success: boolean } };

export type UserAvatarFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, avatarThumbUrl?: string | null };

export const CachedUiAccessContextFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CachedUiAccessContext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UiAccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canInternalAdmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<CachedUiAccessContextFragment, unknown>;
export const CachedViewerContextFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CachedViewerContext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDisplayAs"}}]}}]} as unknown as DocumentNode<CachedViewerContextFragment, unknown>;
export const UserAvatarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}}]}}]} as unknown as DocumentNode<UserAvatarFragment, unknown>;
export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Users"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const InternalAdminUserSuspendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAdminUserSuspend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminUserSuspendInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminUserSuspend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}}]}}]}}]}}]} as unknown as DocumentNode<InternalAdminUserSuspendMutation, InternalAdminUserSuspendMutationVariables>;
export const InternalAdminUserUnsuspendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAdminUserUnsuspend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminUserUnsuspendInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminUserUnsuspend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}}]}}]}}]}}]} as unknown as DocumentNode<InternalAdminUserUnsuspendMutation, InternalAdminUserUnsuspendMutationVariables>;
export const InternalAdminContactMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalAdminContactMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactMessageStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminContactMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"puzzleWpId"}},{"kind":"Field","name":{"kind":"Name","value":"submitterEmail"}},{"kind":"Field","name":{"kind":"Name","value":"replies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"fromName"}},{"kind":"Field","name":{"kind":"Name","value":"fromEmail"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmail"}},{"kind":"Field","name":{"kind":"Name","value":"senderName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InternalAdminContactMessagesQuery, InternalAdminContactMessagesQueryVariables>;
export const InternalAdminContactMessageUpdateStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAdminContactMessageUpdateStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminContactMessageUpdateStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminContactMessageUpdateStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<InternalAdminContactMessageUpdateStatusMutation, InternalAdminContactMessageUpdateStatusMutationVariables>;
export const InternalAdminContactMessageReplyCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAdminContactMessageReplyCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminContactMessageReplyCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminContactMessageReplyCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"replies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"fromName"}},{"kind":"Field","name":{"kind":"Name","value":"fromEmail"}},{"kind":"Field","name":{"kind":"Name","value":"senderEmail"}},{"kind":"Field","name":{"kind":"Name","value":"senderName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InternalAdminContactMessageReplyCreateMutation, InternalAdminContactMessageReplyCreateMutationVariables>;
export const InternalAdminJourneyLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalAdminJourneyLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hidden"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"puzzleWpId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminJourneyLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"hidden"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hidden"}}},{"kind":"Argument","name":{"kind":"Name","value":"puzzleWpId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"puzzleWpId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenAt"}},{"kind":"Field","name":{"kind":"Name","value":"authorDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"photoThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"puzzle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wpId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InternalAdminJourneyLogsQuery, InternalAdminJourneyLogsQueryVariables>;
export const InternalAdminJourneyLogHideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAdminJourneyLogHide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminJourneyLogHideInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminJourneyLogHide"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journeyLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenAt"}}]}}]}}]}}]} as unknown as DocumentNode<InternalAdminJourneyLogHideMutation, InternalAdminJourneyLogHideMutationVariables>;
export const InternalAdminJourneyLogUnhideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAdminJourneyLogUnhide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminJourneyLogUnhideInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminJourneyLogUnhide"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journeyLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiddenAt"}}]}}]}}]}}]} as unknown as DocumentNode<InternalAdminJourneyLogUnhideMutation, InternalAdminJourneyLogUnhideMutationVariables>;
export const InternalAdminJourneyLogDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAdminJourneyLogDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminJourneyLogDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminJourneyLogDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedId"}}]}}]}}]} as unknown as DocumentNode<InternalAdminJourneyLogDeleteMutation, InternalAdminJourneyLogDeleteMutationVariables>;
export const InternalAdminPuzzlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalAdminPuzzles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PuzzleStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminPuzzles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wpId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"pieceCount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"registeredOn"}}]}}]}}]}}]} as unknown as DocumentNode<InternalAdminPuzzlesQuery, InternalAdminPuzzlesQueryVariables>;
export const InternalAdminPuzzleUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAdminPuzzleUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminPuzzleUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminPuzzleUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"puzzle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"pieceCount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<InternalAdminPuzzleUpdateMutation, InternalAdminPuzzleUpdateMutationVariables>;
export const InternalAdminPuzzleRegenerateQrCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAdminPuzzleRegenerateQrCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InternalAdminPuzzleRegenerateQrCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalAdminPuzzleRegenerateQrCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"puzzle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<InternalAdminPuzzleRegenerateQrCodeMutation, InternalAdminPuzzleRegenerateQrCodeMutationVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const UiAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UiAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uiAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canInternalAdmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UiAccessQuery, UiAccessQueryVariables>;
export const ViewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CachedViewerContext"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CachedViewerContext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDisplayAs"}}]}}]} as unknown as DocumentNode<ViewerQuery, ViewerQueryVariables>;
export const DashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"puzzlesLoggedCount"}},{"kind":"Field","name":{"kind":"Name","value":"puzzlesRegisteredCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPiecesLogged"}},{"kind":"Field","name":{"kind":"Name","value":"myPuzzles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wpId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"pieceCount"}},{"kind":"Field","name":{"kind":"Name","value":"homeCity"}},{"kind":"Field","name":{"kind":"Name","value":"homeState"}},{"kind":"Field","name":{"kind":"Name","value":"photoThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"journeyLogCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"viewerHasLogged"}},{"kind":"Field","name":{"kind":"Name","value":"journeyLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"3"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DashboardQuery, DashboardQueryVariables>;
export const LandingStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LandingStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"puzzlesRegisteredCount"}},{"kind":"Field","name":{"kind":"Name","value":"journeyLogsCount"}},{"kind":"Field","name":{"kind":"Name","value":"featuredPuzzles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wpId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"pieceCount"}},{"kind":"Field","name":{"kind":"Name","value":"photoThumbUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentMapStops"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"authorDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"photoThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"puzzle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wpId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LandingStatsQuery, LandingStatsQueryVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CredentialsUserAuthInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"login"},"name":{"kind":"Name","value":"credentialsUserAuth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const EmailTokenAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailTokenAuth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailTokenUserAuthInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailTokenUserAuth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"csrfToken"}}]}}]}}]} as unknown as DocumentNode<EmailTokenAuthMutation, EmailTokenAuthMutationVariables>;
export const EmailAuthChallengeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmailAuthChallenge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EmailUserAuthChallengeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailUserAuthChallenge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"needsProfile"}}]}}]}}]} as unknown as DocumentNode<EmailAuthChallengeMutation, EmailAuthChallengeMutationVariables>;
export const ViewerUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}}]}}]}}]}}]} as unknown as DocumentNode<ViewerUpdateMutation, ViewerUpdateMutationVariables>;
export const UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CachedViewerContext"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CachedViewerContext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDisplayAs"}}]}}]} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const ViewerSoftDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewerSoftDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewerSoftDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerSoftDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ViewerSoftDeleteMutation, ViewerSoftDeleteMutationVariables>;
export const ViewerDataExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerDataExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerDataExport"}}]}}]} as unknown as DocumentNode<ViewerDataExportQuery, ViewerDataExportQueryVariables>;
export const PublicProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"publicDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"publicMemberSince"}},{"kind":"Field","name":{"kind":"Name","value":"publicPuzzlesLoggedCount"}},{"kind":"Field","name":{"kind":"Name","value":"publicPuzzlesRegisteredCount"}},{"kind":"Field","name":{"kind":"Name","value":"publicDistinctStatesVisited"}},{"kind":"Field","name":{"kind":"Name","value":"publicJourneyLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"photoThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"authorDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIsAuthor"}},{"kind":"Field","name":{"kind":"Name","value":"puzzle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wpId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"pieceCount"}},{"kind":"Field","name":{"kind":"Name","value":"photoThumbUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"publicRegisteredPuzzles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wpId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"pieceCount"}},{"kind":"Field","name":{"kind":"Name","value":"homeCity"}},{"kind":"Field","name":{"kind":"Name","value":"homeState"}},{"kind":"Field","name":{"kind":"Name","value":"photoThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"journeyLogCount"}}]}}]}}]}}]} as unknown as DocumentNode<PublicProfileQuery, PublicProfileQueryVariables>;
export const JourneyLogForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JourneyLogForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JourneyLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"passedOn"}},{"kind":"Field","name":{"kind":"Name","value":"nextLocation"}},{"kind":"Field","name":{"kind":"Name","value":"displayAs"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIsAuthor"}},{"kind":"Field","name":{"kind":"Name","value":"puzzle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wpId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"pieceCount"}},{"kind":"Field","name":{"kind":"Name","value":"photoThumbUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JourneyLogForEditQuery, JourneyLogForEditQueryVariables>;
export const JourneyLogUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JourneyLogUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JourneyLogUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journeyLogUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journeyLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<JourneyLogUpdateMutation, JourneyLogUpdateMutationVariables>;
export const LogJourneyPuzzleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LogJourneyPuzzle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wpId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"puzzle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wpId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wpId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wpId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"pieceCount"}},{"kind":"Field","name":{"kind":"Name","value":"photoThumbUrl"}}]}}]}}]} as unknown as DocumentNode<LogJourneyPuzzleQuery, LogJourneyPuzzleQueryVariables>;
export const JourneyLogCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JourneyLogCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JourneyLogCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journeyLogCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journeyLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<JourneyLogCreateMutation, JourneyLogCreateMutationVariables>;
export const PuzzleLabelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PuzzleLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wpId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"puzzle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wpId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wpId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wpId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"qrCodeUrl"}}]}}]}}]} as unknown as DocumentNode<PuzzleLabelQuery, PuzzleLabelQueryVariables>;
export const PuzzleTrackingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PuzzleTracking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wpId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"puzzle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wpId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wpId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wpId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"pieceCount"}},{"kind":"Field","name":{"kind":"Name","value":"homeCity"}},{"kind":"Field","name":{"kind":"Name","value":"homeState"}},{"kind":"Field","name":{"kind":"Name","value":"registeredOn"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"journeyLogCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewerIsOwner"}},{"kind":"Field","name":{"kind":"Name","value":"journeyLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedOn"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"authorDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"passedOn"}},{"kind":"Field","name":{"kind":"Name","value":"nextLocation"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"displayOnMap"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"photoThumbUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PuzzleTrackingQuery, PuzzleTrackingQueryVariables>;
export const PuzzleCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PuzzleCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PuzzleCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"puzzleCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"puzzle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wpId"}}]}}]}}]}}]} as unknown as DocumentNode<PuzzleCreateMutation, PuzzleCreateMutationVariables>;
export const ContactMessageCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContactMessageCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactMessageCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactMessageCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ContactMessageCreateMutation, ContactMessageCreateMutationVariables>;